/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createSdtPosition } from '../fn/sdt-position-controller/create-sdt-position';
import { CreateSdtPosition$Params } from '../fn/sdt-position-controller/create-sdt-position';
import { deleteSdtPosition } from '../fn/sdt-position-controller/delete-sdt-position';
import { DeleteSdtPosition$Params } from '../fn/sdt-position-controller/delete-sdt-position';
import { getSdtPosition } from '../fn/sdt-position-controller/get-sdt-position';
import { GetSdtPosition$Params } from '../fn/sdt-position-controller/get-sdt-position';
import { getSdtPositions } from '../fn/sdt-position-controller/get-sdt-positions';
import { GetSdtPositions$Params } from '../fn/sdt-position-controller/get-sdt-positions';
import { getSdtPositionsFiltered } from '../fn/sdt-position-controller/get-sdt-positions-filtered';
import { GetSdtPositionsFiltered$Params } from '../fn/sdt-position-controller/get-sdt-positions-filtered';
import { PageSdtPositionDto } from '../models/page-sdt-position-dto';
import { SdtPositionDto } from '../models/sdt-position-dto';
import { updateSdtPosition } from '../fn/sdt-position-controller/update-sdt-position';
import { UpdateSdtPosition$Params } from '../fn/sdt-position-controller/update-sdt-position';

@Injectable({ providedIn: 'root' })
export class SdtPositionControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSdtPosition()` */
  static readonly GetSdtPositionPath = '/v1/sdtpositions/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSdtPosition()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSdtPosition$Response(params: GetSdtPosition$Params, context?: HttpContext): Observable<StrictHttpResponse<SdtPositionDto>> {
    return getSdtPosition(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSdtPosition$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSdtPosition(params: GetSdtPosition$Params, context?: HttpContext): Observable<SdtPositionDto> {
    return this.getSdtPosition$Response(params, context).pipe(
      map((r: StrictHttpResponse<SdtPositionDto>): SdtPositionDto => r.body)
    );
  }

  /** Path part for operation `updateSdtPosition()` */
  static readonly UpdateSdtPositionPath = '/v1/sdtpositions/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSdtPosition()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSdtPosition$Response(params: UpdateSdtPosition$Params, context?: HttpContext): Observable<StrictHttpResponse<SdtPositionDto>> {
    return updateSdtPosition(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSdtPosition$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSdtPosition(params: UpdateSdtPosition$Params, context?: HttpContext): Observable<SdtPositionDto> {
    return this.updateSdtPosition$Response(params, context).pipe(
      map((r: StrictHttpResponse<SdtPositionDto>): SdtPositionDto => r.body)
    );
  }

  /** Path part for operation `deleteSdtPosition()` */
  static readonly DeleteSdtPositionPath = '/v1/sdtpositions/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSdtPosition()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSdtPosition$Response(params: DeleteSdtPosition$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteSdtPosition(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSdtPosition$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSdtPosition(params: DeleteSdtPosition$Params, context?: HttpContext): Observable<void> {
    return this.deleteSdtPosition$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getSdtPositions()` */
  static readonly GetSdtPositionsPath = '/v1/sdtpositions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSdtPositions()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSdtPositions$Response(params?: GetSdtPositions$Params, context?: HttpContext): Observable<StrictHttpResponse<PageSdtPositionDto>> {
    return getSdtPositions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSdtPositions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSdtPositions(params?: GetSdtPositions$Params, context?: HttpContext): Observable<PageSdtPositionDto> {
    return this.getSdtPositions$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageSdtPositionDto>): PageSdtPositionDto => r.body)
    );
  }

  /** Path part for operation `createSdtPosition()` */
  static readonly CreateSdtPositionPath = '/v1/sdtpositions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSdtPosition()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSdtPosition$Response(params: CreateSdtPosition$Params, context?: HttpContext): Observable<StrictHttpResponse<SdtPositionDto>> {
    return createSdtPosition(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSdtPosition$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSdtPosition(params: CreateSdtPosition$Params, context?: HttpContext): Observable<SdtPositionDto> {
    return this.createSdtPosition$Response(params, context).pipe(
      map((r: StrictHttpResponse<SdtPositionDto>): SdtPositionDto => r.body)
    );
  }

  /** Path part for operation `getSdtPositionsFiltered()` */
  static readonly GetSdtPositionsFilteredPath = '/v1/sdtpositions/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSdtPositionsFiltered()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getSdtPositionsFiltered$Response(params: GetSdtPositionsFiltered$Params, context?: HttpContext): Observable<StrictHttpResponse<PageSdtPositionDto>> {
    return getSdtPositionsFiltered(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSdtPositionsFiltered$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getSdtPositionsFiltered(params: GetSdtPositionsFiltered$Params, context?: HttpContext): Observable<PageSdtPositionDto> {
    return this.getSdtPositionsFiltered$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageSdtPositionDto>): PageSdtPositionDto => r.body)
    );
  }

}
